import { render } from "./FridgeMyAssistListEditPage.vue?vue&type=template&id=76fbf10b&scoped=true&ts=true"
import script from "./FridgeMyAssistListEditPage.vue?vue&type=script&lang=ts"
export * from "./FridgeMyAssistListEditPage.vue?vue&type=script&lang=ts"

import "./FridgeMyAssistListEditPage.vue?vue&type=style&index=0&id=76fbf10b&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76fbf10b"]])

export default __exports__